import React from 'react';
export function Footer() {
  return <footer className="bg-[#0A1F33] text-white/70 py-16 px-4 sm:px-6 lg:px-8 border-t border-white/10" data-id="element-536" data-mp="32wd2cf6gdjt0">
      <div className="max-w-7xl mx-auto grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-12 lg:gap-8" data-id="element-537" data-mp="3ggk8mvu5ve02">
        {/* Column 1 */}
        <div className="lg:pr-8" data-id="element-538" data-mp="36pfutzg81z6t">
          <img src="https://cdn.magicpatterns.com/uploads/pa3Fk96C6qU6AFqdF9EfnU/ChatGPT_Image_Aug_25,_2026,_10_57_05_AMff.png" alt="SyNeural — Creating an Intelligent Web" className="h-10 w-auto mb-5 brightness-0 invert" data-id="element-539" data-mp="36qhhl16loa4d" />
          <p className="text-sm leading-relaxed" data-id="element-540" data-mp="3lem0o69kenno">
            Building intelligence in the world.
          </p>
        </div>

        {/* Column 2 */}
        <div data-id="element-541" data-mp="3qbvojhhb2r9e">
          <h4 className="text-white font-heading font-bold mb-6 uppercase tracking-wider text-sm" data-id="element-542" data-mp="3qfji2gmr3do4">
            Products
          </h4>
          <ul className="space-y-3 text-sm" data-id="element-543" data-mp="2ey0bce9yoskt">
            <li data-id="element-544" data-mp="2ezutjktum6l7">
              <a href="/human-capability" className="hover:text-white transition-colors" data-id="element-545" data-mp="2ew6yuico3e4w">
                Human Capability Platform
              </a>
            </li>
            <li data-id="element-546" data-mp="3gctqustskxtg">
              <a href="/cji" className="hover:text-white transition-colors pl-3" data-id="element-547" data-mp="3v7ggw4mssibe">
                CJI
              </a>
            </li>
            <li data-id="element-548" data-mp="3q7u1ppnesrzy">
              <a href="/ncji" className="hover:text-white transition-colors pl-3" data-id="element-549" data-mp="3q7bvc0718xeb">
                NCJI
              </a>
            </li>
            <li data-id="element-550" data-mp="3474fms9a7yq">
              <a href="/semantic-knowledge" className="hover:text-white transition-colors" data-id="element-551" data-mp="34pa1a0t5yjb">
                Semantic Knowledge Platform
              </a>
            </li>
            <li data-id="element-552" data-mp="cus3fbbudei6">
              <a href="/llm-vs-skp" className="hover:text-white transition-colors pl-3" data-id="element-553" data-mp="cu8tagsfnuep">
                LLM vs. SKP
              </a>
            </li>
            <li data-id="element-554" data-mp="ms6d8s39f51i">
              <a href="/solutions" className="hover:text-white transition-colors" data-id="element-555" data-mp="mspqhvhyt597">
                Solutions
              </a>
            </li>

          </ul>
        </div>

        {/* Column 3 */}
        <div data-id="element-556" data-mp="ys3eud1iswzi">
          <h4 className="text-white font-heading font-bold mb-6 uppercase tracking-wider text-sm" data-id="element-557" data-mp="yrv4arsve3rh">
            Applications
          </h4>
          <ul className="space-y-3 text-sm" data-id="element-558" data-mp="18k98dr7f7mgt">
            <li data-id="element-559" data-mp="18m3s526yh8jb">
              <a href="/education" className="hover:text-white transition-colors" data-id="element-560" data-mp="1clmaprbb17iz">
                Education
              </a>
            </li>
            <li data-id="element-561" data-mp="1hmife73hcxpg">
              <a href="/employers" className="hover:text-white transition-colors" data-id="element-562" data-mp="1mk1sv4sct6gc">
                Employers
              </a>
            </li>
            <li data-id="element-563" data-mp="3ob55u0ppux42">
              <a href="/civil-society" className="hover:text-white transition-colors" data-id="element-564" data-mp="3obolfarw99ex">
                Civil Society
              </a>
            </li>
            <li data-id="element-565" data-mp="2afnc9bcbnzzr">
              <a href="/government" className="hover:text-white transition-colors" data-id="element-566" data-mp="2ag5eqppkvag4">
                Government
              </a>
            </li>
            <li data-id="element-567" data-mp="21m0kdwb8jgvu">
              <a href="/leadership" className="hover:text-white transition-colors" data-id="element-568" data-mp="21nlexlxjuztp">
                Leadership
              </a>
            </li>
          </ul>
        </div>

        {/* Column 4 */}
        <div data-id="element-569" data-mp="2pced7p1n9jrh">
          <h4 className="text-white font-heading font-bold mb-6 uppercase tracking-wider text-sm" data-id="element-570" data-mp="2pcntum0sueki">
            Company
          </h4>
          <ul className="space-y-3 text-sm" data-id="element-571" data-mp="2kc021y4qxtp8">
            <li data-id="element-572" data-mp="2kf4c3c4w7jnt">
              <a href="/about" className="hover:text-white transition-colors" data-id="element-573" data-mp="2fegmmuwbbavp">
                About
              </a>
            </li>
            <li data-id="element-574" data-mp="18yxkp0utp040">
              <a href="/research" className="hover:text-white transition-colors" data-id="element-575" data-mp="18zfr2qb78upn">
                Research
              </a>
            </li>
            <li data-id="element-576" data-mp="2ru6dzsopnbj2">
              <a href="/roadmap" className="hover:text-white transition-colors" data-id="element-577" data-mp="2rtmui7jewf2x">
                Roadmap
              </a>
            </li>
            <li data-id="element-578" data-mp="2iwm7a482wn12">
              <a href="/partnerships" className="hover:text-white transition-colors" data-id="element-579" data-mp="2isyi1h9o2ms5">
                Partnerships
              </a>
            </li>
            <li data-id="element-580" data-mp="3bhm4hg65ji7a">
              <a href="/contact" className="hover:text-white transition-colors" data-id="element-581" data-mp="3flbr4039nppo">
                Contact
              </a>
            </li>
          </ul>
        </div>
      </div>

      <div className="max-w-7xl mx-auto mt-16 pt-8 border-t border-white/10 text-xs flex flex-col md:flex-row justify-between items-center gap-4" data-id="element-582" data-mp="31nn7swoukqmq">
        <p data-id="element-583" data-mp="1q6499hm7pbui">&copy; {new Date().getFullYear()} SyNeural. All rights reserved.</p>
        <div className="flex gap-6" data-id="element-584" data-mp="1v574698ha1or">
          <a href="/privacy" className="hover:text-white transition-colors" data-id="element-585" data-mp="1v69ticq5jw2k">
            Privacy Policy
          </a>
          <a href="/terms" className="hover:text-white transition-colors" data-id="element-586" data-mp="1nkefosq1xxzi">
            Terms of Service
          </a>
        </div>
      </div>
    </footer>;
}